var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"func-search-gallery-top"},[_c('a',{staticClass:"btn btn-default btn-lg",attrs:{"role":"button"},on:{"click":function($event){return _vm.clickLink()}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }